import React from "react";
import { DetalleProducto } from "../Model";
import { Badge, Button, ListGroup, Modal } from "react-bootstrap";
import { currencyFormat } from "../../../../utils/numberUtils";

export const CarritoModal = ({
  detallesPorProducto,
  show,
  onClose,
  total,
}: {
  detallesPorProducto: Map<string, DetalleProducto>;
  show: boolean;
  onClose: () => void;
  total: number;
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Carrito de compras</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section>
          <Detalles
            detalles={Array.from(detallesPorProducto.values())}
            total={total}
          />
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  );
};

const Detalles = ({
  detalles,
  total,
}: {
  detalles: DetalleProducto[];
  total: number;
}) => {
  if (detalles.length > 0) {
    return (
      <section>
        <div className="mb-3">
          <ListGroup as="ol" numbered>
            {detalles.map((d, i) => (
              <Detalle key={i} detalle={d} />
            ))}
          </ListGroup>
        </div>
        <div className="d-flex flex-row-reverse">
          <strong>Total: {currencyFormat(total)}</strong>
        </div>
      </section>
    );
  }

  return <p>No ha seleccionado ningún artículo.</p>;
};

const Detalle = ({ detalle }: { detalle: DetalleProducto }) => {
  return (
    <ListGroup.Item
      as="li"
      className="d-flex justify-content-between align-items-start"
    >
      <div className="ms-2 me-auto">
        <div className="fw-bold">{detalle.nombre}</div>
        {`Cantidad: ${detalle.cantidad}`}
      </div>
      <Badge bg="success" pill>
        {currencyFormat(detalle.valor)}
      </Badge>
    </ListGroup.Item>
  );
};
